import React from 'react';
import {
  createTheme,
  withStyles,
  MuiThemeProvider,
} from '@material-ui/core';

import CircularProgress from '@material-ui/core/CircularProgress';

export const theme = createTheme((theme) => ({
  root: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
}));

export const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    height: 400,
  },
};

const CircularIndeterminate = (props) => {
  const { classes } = props;

  return (
    <MuiThemeProvider theme={theme}>
      {void window.scrollTo(0, 0)}
      <div className={`${classes.root} flex-column`}>
        <CircularProgress />
      </div>
    </MuiThemeProvider>
  );
};

export default withStyles(styles)(CircularIndeterminate);